import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { getFrasesThunk } from "../store/reducers/frases/frases.thunks";
import FrasesHeader from "./frases/FrasesHeader";
import FrasesTable from "./frases/FrasesTable";
import FraseViewModal from "./frases/FraseViewModal";
import ConfirmToggleModal from "./frases/ConfirmToggleModal";
import FraseFormModal from "./frases/FraseFormModal";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import {
  clearFrasesError,
  setPage,
} from "../store/reducers/frases/frases.reducer";

const FrasesListLayer = () => {
  const dispatch = useDispatch();
  const {
    list,
    loading,
    error,
    page,
    search,
    talentoFilter,
    isRandomFilter,
    count,
  } = useSelector((state) => state.frases);

  useEffect(() => {
    dispatch(
      getFrasesThunk({
        page,
        search,
        talento: talentoFilter,
        isRandom: isRandomFilter,
      }),
    );
  }, [dispatch, page, search, talentoFilter, isRandomFilter]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <FrasesHeader />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearFrasesError())}
          />
        )}

        {loading ? (
          <Loader center text="Cargando frases..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            <FrasesTable frases={list} search={search} />

            {count > 0 && (
              <Pagination
                page={page}
                count={count}
                pageSize={10}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>

      {/* Modales */}
      <FraseViewModal />
      <FraseFormModal />
      <ConfirmToggleModal />
    </div>
  );
};

export default FrasesListLayer;
